import SkillBlock from "./SkillBlock"
import Skills from "./Skills"
import Education from "./Education"
import Experience from "./Experience"

const Resume = ({ navBarHeight }) => {
  return (
    <div
      className="min-h-screen"
      style={{ paddingTop: navBarHeight }}
    >
      <div className="page-frame flex flex-col gap-6 pb-10 md:flex-row">
        <div className="w-full md:w-[24rem] md:flex-shrink-0">
          <div className="section-panel glass-panel glass-panel-strong md:sticky md:top-28">
        <div className="flex flex-col items-center">
          <div className="section-kicker mb-6">Profile</div>
          <img
            alt="Profile"
            src="/static/images/alka3.jpg"
            className="rounded-full w-32 h-32 md:w-52 md:h-52 border-4 border-primary/20 p-1"
          />
          <h2 className="text-xl md:text-2xl mt-5 font-semibold text-center">Mahamadou ABOUBACAR</h2>
          <h4 className="text-base md:text-lg text-base-content/80">Lead Data Engineer</h4>
          <h5 className="text-sm md:text-base tracking-wide text-base-content/60 text-center">
            Data Engineering | Analytics Platforms | Machine Learning
          </h5>
          <hr className="border-t border-base-content/20 w-full my-6" />
          <p className="text-sm md:text-base mb-4 rounded-full border border-primary/15 bg-primary/8 px-4 py-2 text-primary">
            Freelance consultant · Tech Lead Analytics Data Platform
          </p>
          <p className="text-sm md:text-base text-justify leading-7 text-base-content/78">
            I am a data engineer and analytics platform lead with{" "}
            {new Date().getFullYear() - 2018}+ years of experience delivering
            production-grade data and ML solutions across energy, transport,
            defense, and consulting environments.
            <br />
            I specialize in Databricks, AWS, Spark, SQL, Python, and Terraform
            to build reliable ingestion pipelines, administer analytics
            platforms, and help teams industrialize data products and ML use
            cases.
            <br />
            My background spans data science, computer vision, NLP, and ML
            research, which helps me bridge platform engineering with applied
            AI projects while supporting stakeholders through framing, user
            enablement, training, and adoption.
            <br />
            I continue exploring computer vision, on-device ML, and
            high-performance languages through side projects on this website and
            also
            <a
              href="https://github.com/AlkaSaliss?tab=repositories"
              rel="noopener noreferrer"
              target="_blank"
              className="link link-primary"
            >
              {" "}
              on github.
            </a>
          </p>
        </div>
          </div>
        </div>
      <div className="w-full flex-grow space-y-6">
        <div className="section-panel glass-panel glass-panel-strong">
            <div className="section-kicker mb-5">Experience</div>
            <Experience
              startYear="July 2024"
              endYear="Now"
              jobName="Lead Data Engineer - Data & Analytics Platform"
              company="EDF Power Solutions, France"
              team="DataLab - Analytics"
              showSubjectList={false}
              subject="Deployed and now administer a Databricks-based DataLab platform serving analytics and ML use cases across multiple EDF business units and countries. Build ingestion and ETL pipelines from APIs, databases, and AWS services such as S3, Redshift, and RDS, while driving adoption through user enablement, training, and support sessions."
              methods="Platform Engineering | Data Ingestion | ETL Pipelines | Monitoring & Alerting"
              tools="Databricks | Spark | SQL | AWS (S3, Athena, Redshift, RDS, SageMaker, Glue, IAM) | GitLab | Terraform | Terragrunt"
            />
            <Experience
              startYear="October 2021"
              endYear="June 2024"
              jobName="Senior Consultant Data Scientist | Data Engineer"
              company="Quantmetry | Capgemini, France"
              team="Computer Vision"
              showSubjectList={true}
              subject={[
                "Led data engineering work for EDF Renewables within a team building AWS pipelines with Lambda, SQS, S3, Athena, Redshift, RDS, EventBridge, and Grafana to ingest and process data from solar sites worldwide for production-performance KPIs.",
                "Built a data application for a transport-sector client that consolidated multiple data sources into a formatted Excel reporting workflow, reducing analysis time from 1-2 weeks to less than 10 minutes.",
                "Delivered consulting engagements spanning uncertainty quantification for image segmentation, tweet scraping and topic or sentiment analysis, supply-chain web scraping, and training content creation on trustworthy AI topics.",
              ]}
              methods="Data Engineering | Data Processing | Machine Learning | Deep Learning | Analytics | Software Engineering"
              tools="AWS | Python | Spark | PyTorch | Scikit-learn | Docker | Linux | Git | Streamlit"
            />
            <Experience
              startYear="Nov 2018"
              endYear="Oct 2021"
              jobName="Research Engineer - Machine Learning"
              company="Atos, France"
              team="Machine Intelligence for Cyber Security"
              showSubjectList={true}
              subject={[
                <>
                  Designed machine-learning frameworks for cyber threat
                  detection and contributed to a patent on insider-threat
                  detection using user activity profiling (
                  <a
                    href="https://shorturl.at/ucnw8"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="link link-primary"
                  >
                    link
                  </a>
                  )
                </>,
                "Developed computer-vision segmentation models for security video analytics and surveillance use cases.",
              ]}
              methods="Machine Learning | Deep Learning | Data Analysis | Software Engineering"
              tools="Python | PyTorch | TensorFlow/Keras | Scikit-learn | Docker | Linux | Spark"
            />
            <Experience
              startYear="Apr 2018"
              endYear="Sep 2018"
              jobName="Deep learning intern"
              company="Equancy, Paris, France"
              team="Data Intelligence"
              showSubjectList={false}
              subject="Developed a sequence-to-sequence NLP prototype that translated business questions into SQL queries so non-technical users could access insights from enterprise data."
              methods="Sequence-to-sequence Models | NLP"
              tools="Python | Tensorflow/Keras | Spacy | Scikit-learn | AWS"
            />
            <Experience
              startYear="June 2017"
              endYear="Aug 2017"
              jobName="Statistician intern"
              company="Le Crédit Lyonnais (LCL Bank), Paris region, France"
              team="Quantitative Models Validation"
              showSubjectList={false}
              subject="Analyzed anomalies in customer credit-risk data to support quantitative model validation."
              methods="Regression models | Exploratory data analysis"
              tools="SAS"
            />
            <Experience
              startYear="Feb 2016"
              endYear="June 2016"
              jobName="Statistician/Economist intern"
              company="Laboratoire de Recherches Economiques et Monétaires (LAREM), Dakar, Sénégal"
              team="LAREM"
              showSubjectList={false}
              subject="Studied the factors influencing innovation in small and medium-sized enterprises in Ivory Coast."
              methods="Multivariate Probit Models | Exploratory Data Analysis | Statistical Modelling"
              tools="R | Stata"
            />
        </div>
        <div className="section-panel glass-panel glass-panel-strong">
            <div className="section-kicker mb-5">Education</div>
            <Education
              startYear={2020}
              endYear={2020}
              degree="Data Engineering Nanodegree"
              schoolName="UDACITY -Online"
              major="ETL pipelines with PostgreSQL | ETL with AWS RedShift/S3 | Big Data with Pyspark and AWS EMR | Data pipelines with Airflow"
            />
            <Education
              startYear={2016}
              endYear={2018}
              degree="Engineering degree in Data Science / Statistics / Data Engineering"
              schoolName="ENSAI - Rennes, France"
              major="Machine Learning Modeling | Statistics/Econometrics | Big Data Engineering | Software & Web Development"
            />
            <Education
              startYear={2012}
              endYear={2016}
              degree="Engineering degree in Statistics / Economics"
              schoolName="ENSAE - Dakar, Senegal"
              major="Statistical modelling | Econometrics | Survey Data collection and analysis | Economics"
            />
        </div>
        <div className="section-panel glass-panel glass-panel-strong">
            <div className="section-kicker mb-5">Skills</div>
            <SkillBlock blockName="Data Engineering">
              <Skills
                skill="Databricks, Spark, SQL, and AWS ingestion pipelines"
                progress={74}
              />
              <Skills skill="Data warehousing with Redshift, Athena, and RDS" progress={74} />
              <Skills
                skill="Data processing with Pandas, Polars, and Spark"
                progress={90}
              />
              <Skills
                skill="Monitoring and alerting with CloudWatch, SNS, and Grafana"
                progress={74}
              />
              <Skills
                skill="Infrastructure and delivery with Terraform, Terragrunt, and CI/CD"
                progress={74}
              />
            </SkillBlock>
            <hr className="border-t border-base-content/15 my-6" />
            <SkillBlock blockName="ML | Analytics">
              <Skills
                skill="Classical ML with linear models, tree-based models, and clustering"
                progress={90}
              />
              <Skills
                skill="Deep learning with PyTorch and TensorFlow/Keras"
                progress={90}
              />
              <Skills
                skill="Data analysis with Pandas, NumPy, and Jupyter"
                progress={90}
              />
              <Skills
                skill="Data visualization with d3.js, Matplotlib, Bokeh, and Plotly"
                progress={80}
              />
            </SkillBlock>
            <hr className="border-t border-base-content/15 my-6" />
            <SkillBlock blockName="Software | Delivery">
              <Skills skill="Python" progress={95} />
              <Skills skill="Linux, Bash, and Docker" progress={70} />
              <Skills skill="Git" progress={80} />
              <Skills skill="Stakeholder enablement, training, and platform support" progress={74} />
              <Skills skill="JavaScript, React, and React Native" progress={49} />
              <Skills skill="C++, Rust, and systems experimentation" progress={49} />
              <Skills skill="Kotlin, Android Studio, HTML, and CSS" progress={49} />
            </SkillBlock>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Resume
